//////////////////////////////////////
// Search Results Page — Live Search

(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {

    const form        = document.querySelector('section.search-results .search-again');
    const searchInput = form?.querySelector('input[type="search"]');
    const liveResults = document.querySelector('section.search-results .live-results');
    const config      = window.searhcSearch || null;

    if (!searchInput || !liveResults || !config) return;

    let debounceTimer = null;

    searchInput.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const query = searchInput.value.trim();

      if (query.length < 2) {
        liveResults.innerHTML = '';
        liveResults.classList.remove('has-results');
        return;
      }

      debounceTimer = setTimeout(async () => {
        const url = `${config.restUrl}?q=${encodeURIComponent(query)}&limit=6`;
        const res = await fetch(url, {
          headers: { 'X-WP-Nonce': config.nonce }
        });
        const data = await res.json();

        if (!data.results?.length) {
          liveResults.innerHTML = '<div class="no-matches">No results found</div>';
          liveResults.classList.add('has-results');
          return;
        }

        const items = data.results.map(r =>
          `<a href="${r.url}" class="live-result">
            <span class="live-type">${r.type_label}</span>
            <span class="live-title">${r.title}</span>
          </a>`
        ).join('');

        const viewAll = data.total > 6
          ? `<a href="${config.searchUrl}${encodeURIComponent(query)}" class="view-all">View all ${data.total} results</a>`
          : '';

        liveResults.innerHTML = items + viewAll;
        liveResults.classList.add('has-results');
      }, 300);
    });

  });
})();
